import { IConfigMobile, IResponseConfigMobile } from '../types';
import { transformToHexColorString } from '~/utils/formatter';

export const configMobileDataCast = (data: IResponseConfigMobile): IConfigMobile => {
  const colors = data.colors;
  const layout = data.layouts;
  const config = data.configuration;

  return {
    colors: {
      mainColor: colors.main_color_app || '',
      // mapControlsColor: colors.map_controls_color || '',
      tabBarTextColor: colors.tab_bar_text_color || '',
      categorySelectionColor: colors.second_color_app || '',
      tabBarSelectionColor: colors.tab_bar_selection_color_app || '',
      priceColor: colors.price_color_app || '',
      saveButtonBackgroundColor: colors.save_btn_bg_color_app || '',
    },
    layout: {
      timePickerPosition: config.time_picker_position,
      menuLayout: layout.menu_layout,
      menuListLayout: layout.menu_list_layout,
    },
    configuration: {
      firebase: {
        apiKey: config.firebase.firebase_api_key || '',
        projectId: config.firebase.firebase_project_id || '',
        secondApiKey: config.firebase.sub_firebase_api_key || '',
        secondProjectId: config.firebase.sub_firebase_project_id || '',
        appStaffApiKey: config.firebase.app_staff_firebase_api_key || '',
        appStaffProjectId: String(config.firebase.app_staff_firebase_project_id) || '',
      },
      firebaseWeb: {
        apiKey: config.firebase_web.web_api_key || '',
        authDomain: config.firebase_web.web_auth_domain || '',
        projectId: config.firebase_web.web_project_id || '',
        storageBucket: config.firebase_web.web_storage_bucket || '',
        messagingSenderId: config.firebase_web.web_messaging_sender_id || '',
        appId: config.firebase_web.web_app_id || '',
        measurementId: config.firebase_web.web_measurement_id || '',
      },
    },
  };
};

export const getConfigMobileParams = (data: IConfigMobile) => {
  const colors = data.colors;
  const layout = data.layout;
  const config = data.configuration;

  return {
    // colors
    main_color_app: transformToHexColorString(colors.mainColor),
    // map_controls_color: transformToHexColorString(colors.mapControlsColor),
    tab_bar_text_color: transformToHexColorString(colors.tabBarTextColor),
    second_color_app: transformToHexColorString(colors.categorySelectionColor),
    tab_bar_selection_color_app: transformToHexColorString(colors.tabBarSelectionColor),
    price_color_app: transformToHexColorString(colors.priceColor),
    save_btn_bg_color_app: transformToHexColorString(colors.saveButtonBackgroundColor),
    // layout
    time_picker_position: layout.timePickerPosition,
    menu_layout: layout.menuLayout,
    menu_list_layout: layout.menuListLayout,
    // firebase
    firebase_api_key: config.firebase.apiKey || null,
    firebase_project_id: config.firebase.projectId || null,
    sub_firebase_api_key: config.firebase.secondApiKey || null,
    sub_firebase_project_id: config.firebase.secondProjectId || null,
    app_staff_firebase_api_key: config.firebase.appStaffApiKey || null,
    app_staff_firebase_project_id: config.firebase.appStaffProjectId || null,
    // firebase web
    web_api_key: config.firebaseWeb.apiKey || null,
    web_auth_domain: config.firebaseWeb.authDomain || null,
    web_project_id: config.firebaseWeb.projectId || null,
    web_storage_bucket: config.firebaseWeb.storageBucket || null,
    web_messaging_sender_id: config.firebaseWeb.messagingSenderId || null,
    web_app_id: config.firebaseWeb.appId || null,
    web_measurement_id: config.firebaseWeb.measurementId || null,
  };
};
